import FileUploadView from './FileUpload.view';
export * from './FileUpload.view';

export const FileUpload = (props) => FileUploadView(props);

export default FileUpload;

